import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import FileSelectorRow from './fileselectorrow';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { ScaleLoader } from 'react-spinners';

class FileSelector extends Component {

    pickFile = (e) => {
        this.fileInput.click()
    }

    deleteFiles = () => {
        if (this.props.files) {
            this.props.deleteFiles (this.props.files);
        }
    }

    onChange = (e) => {
        e.preventDefault();
        var file = {id: '',
                    type:  e.target.files[0].type,
                    name:  e.target.files[0].name,
                    size:  e.target.files[0].size,
                    checked: false,
                    local: true,
                    data: [],
                    blob: e.target.files[0]};
        this.props.uploadFile (this.props.id, file);
    }

    checkBoxTicked = (index) => {
        this.props.updateChecks(index);
    }

    renderRows = () => {
        if (this.props.files && this.props.files.length > 0) {
            const rows = this.props.files.map((file,index) =>
                <FileSelectorRow key={index} index={index} file={file} checkBoxTicked={this.checkBoxTicked}/>
            )
            rows.unshift(<FileSelectorRow key="header" header/>);
            rows.push(<div key="spacer" className="spacer-sm"></div>);
            return rows;
        }
    }

    renderDelete = () => {
        if (this.props.files && this.props.files.length > 0) {
            return (
                <div className="fs-delete-button-container">
                    <button  className="fs-delete-button" type="button" onClick={this.deleteFiles}>Delete</button>
                    <div key="spacer" className="spacer-lg"></div>
                </div>
            )
        }
    }

    renderFileSection = () => {
        if (this.props.fileloading) {
            return(
                <div className='sweet-loading'>
                    <ScaleLoader
                         color={'#36D7B7'}
                         loading={this.props.fileloading}
                    />
                </div>
            );
        } else {
            return (
                <div>
                    <div>
                        {this.renderRows()}
                    </div>
                    <div>
                        {this.renderDelete()}
                    </div>
                </div>
            );
        }
    }

    render() {
      return (
        <div>
            <div className="spacer-lg"></div>
            <div className="fs-header">
                {this.props.label}
            </div>
            <div className="spacer-sm"></div>
            <div>
                {this.renderFileSection()}
            </div>
            <input id="myInput" type="file" ref={(ref) => this.fileInput = ref} style={{ display: 'none' }} onChange={this.onChange} multiple/>
            <MuiThemeProvider>
                <FloatingActionButton mini={true}
                    className="floatingButton"
                    onClick={this.pickFile}
                    >
                    <ContentAdd />
                </FloatingActionButton>
            </MuiThemeProvider>
            <div className="spacer-sm"></div>
        </div>
      );
    }
  }

  function mapStateToProps(state) {
      return { files: state.app.files,
                fileloading: state.app.fileloading };
  }

  export default connect(mapStateToProps, actions)(FileSelector);



// WEBPACK FOOTER //
// ./src/components/fileselector.js